import { Descriptions } from "@/components/v2";
import { Card } from "@rumbledirect/ui";

export const ClaimDossierInsuranceInfoCard = ({
  isLoading,
}: {
  isLoading: boolean;
}) => {
  return (
    <Card loading={isLoading} className="w-full" title="Polisgegevens">
      <Descriptions
        layout="horizontal"
        items={[
          {
            key: `polis-1`,
            label: `Eigen risico`,
            children: `€ 500,-`,
          },
          {
            key: `polis-2`,
            label: `Dekking`,
            children: `WA + Casco`,
          },
          {
            key: `polis-3`,
            label: `Verzekering`,
            children: `Intern verzekerd`,
          },
        ]}
        labelStyle={{ width: "300px", verticalAlign: "top" }}
      />
    </Card>
  );
};
